import "@/index.css";
import Navbar from "@/components/pharmacy/Navbar";
import Hero from "@/components/pharmacy/Hero";
import Announcements from "@/components/pharmacy/Announcements";
import About from "@/components/pharmacy/About";
import Promise from "@/components/pharmacy/Promise";
import ProductRange from "@/components/pharmacy/ProductRange";
import Services from "@/components/pharmacy/Services";
import Features from "@/components/pharmacy/Features";
import GoogleReviews from "@/components/pharmacy/GoogleReviews";
import ClinicalTrial from "@/components/pharmacy/ClinicalTrial";
import RefillForm from "@/components/pharmacy/RefillForm";
import Location from "@/components/pharmacy/Location";
import InsurancePartners from "@/components/pharmacy/InsurancePartners";
import Footer from "@/components/pharmacy/Footer";
import WhatsAppButton from "@/components/pharmacy/WhatsAppButton";

function App() {
  return (
    <div className="App font-jakarta">
      <Navbar />
      <main>
        <Hero />
        <About />
        <RefillForm />
        <Promise />
        <ProductRange />
        <Announcements />
        <Services />
        <Features />
        <GoogleReviews />
        <ClinicalTrial />
        <Location />
        <InsurancePartners />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
